/**
 * @test-file: BannerPlaceholder.test.tsx
 * @test-coverage: 14 tests (sizes, pill, title, note, children, className)
 * @last-updated: 2025-12-28
 */
import React, { type JSX } from 'react';

type BannerProps = {
  size?: 'small' | 'wide';
  pill?: string;
  title?: string;
  note?: string;
  children?: React.ReactNode;
  className?: string;
};

export function BannerPlaceholder({ size = 'wide', pill, title, note, children, className }: BannerProps): JSX.Element {
  /* Ohne Inhalt UND ohne Beschriftung bleibt nichts uebrig, was zu zeigen
     waere. Die Flaeche fuer eine Anzeige freizuhalten ist richtig, solange
     etwas nachgeladen wird und das Layout sonst unter dem Leser verrutscht —
     der obere Slot in App.tsx bekommt aber nie `children`, dort stand also in
     Produktion ein leerer grauer Kasten ueber der ganzen Seite. Reserviert
     wird deshalb nur noch, wo auch wirklich etwas einzieht. */
  if (!import.meta.env.DEV && !children) return <></>;

  const classes = ['ui-banner', size === 'small' ? 'small' : 'wide'];
  if (className) classes.push(className);
  return (
    <div className={classes.join(' ')}>
      <div className="banner-copy">
        {/* `pill`, `title` und `note` sind Masshinweise fuer uns — „Banner Slot",
            „Top Banner 1100×160 · Full Width", „Viewports: Desktop 1200×160 …".
            Sie standen bis zum 04.09.2026 auf der oeffentlichen Seite und lasen
            sich fuer Besucher wie ein halbfertiger Auftritt.

            Die FLAECHE bleibt in jedem Fall reserviert: `ui-banner` traegt die
            Groesse, und ein Slot, der erst beim Einbuchen einer Anzeige
            entsteht, verschiebt das Layout unter dem Leser. Nur die
            Beschriftung ist jetzt an die Entwicklung gebunden.

            `children` bleibt ungefiltert — das ist echter Inhalt (eine
            eingebuchte Anzeige), keine Beschriftung. */}
        {import.meta.env.DEV && pill && (
          <div>
            <span className="banner-pill">{pill}</span>
          </div>
        )}
        {import.meta.env.DEV && title && <span>{title}</span>}
        {import.meta.env.DEV && note && <p className="banner-note">{note}</p>}
        {children}
      </div>
    </div>
  );
}
